(() => {
if(!document.getElementById('o-app'))return;

// Revalidate on editing, paste, mobile autofill and returning to this page.
['o-co', 'o-name', 'o-registration', 'o-email', 'o-tel', 'o-address', 'o-postcode', 'o-city', 'o-country', 'o-msg'].forEach(id=>{
  const field=document.getElementById(id);
  ['input','change'].forEach(event=>field.addEventListener(event,()=>oTotals()));
});
window.addEventListener('pageshow',()=>oTotals());
oTotals();

})();
